import styled, { css } from 'styled-components';

export const BannerWrapper = styled.div`
  background-color: #333;
  color: #fff;
  overflow: hidden;
  position: relative;
  text-align: center;

  [class*='FullHeightBannerstyle__FullHeightBanner-sc'] {
    min-height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
  }
`;

export const BreadcrumbWrapper = styled.div`
  svg {
    height: 18px;
  }

  [class*='Breadcrumbsstyle__Breadcrumbs-sc'] {
    flex-wrap: nowrap;
  }

  [class*='Breadcrumbsstyle__BreadcrumbsItem-sc']:last-child {
    min-width: 0;
    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: #9B9B9B;
      font-weight: 400;
    }
  }
`;

export const ContentWrapper = styled.div`
  max-width: 844px;
  text-align: start;

  [class*='Headingstyle__Heading-sc'] {
    font-weight: 400 !important;
    margin-top: 3.5rem;
  }
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 32px;

  > h1:first-child {
    margin-top: 0;
    text-align: center;
    font-weight: 700 !important;
  }

  @media (max-width: 638px) {
    margin-top: 16px;
    margin-bottom: 26px;
  }
`;

export const bgWhite = css`
  background: var(--white);
`;

export const bgAbbey = css`
  background: var(--gallery);
`;

export const RecommendedBannerWrapper = styled.div`
  max-width: 1250px;
  margin: 0 auto;
`;
